module.exports = __webpack_public_path__ + "static/img/SC11.d07fa01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/SC11.jpg
// module id = Mi29
// module chunks = 0